<template>
  <div class="article-view-wrapper" :style="$vuetify.breakpoint.smAndDown ? 'padding: 5%' : ''">
    <!-- Article Title -->
    <div class="article-block">
      <TitleBlock :title="article.title" :has_permission_edit="false" :editing="false"
        :block_id="'title-block'" />
    </div>

    <div class="article-line article-head-space" />
    <!-- Author, Published Date -->
    <div class="article-subheader">
      <h2 class="left" v-if="authors" :style="$vuetify.breakpoint.smAndDown ? 'font-size: 9pt' : ''" v-html="authors" />
      <h3 class="right" :style="$vuetify.breakpoint.smAndDown ? 'font-size: 11pt' : ''">
        {{ getArticleDate(article) }}
      </h3>
    </div>
    <div class="article-space">
      <div class="article-hashtag-container article-block">
        <div v-for="(hashtag, i) in hashtags" :key='`hashtag${i}`'>
          <Hashtag :hashtag="hashtag" :has_permission_edit="false" :is_template="hashtag.is_template"
            :is_show_error="is_show_hashtag_error" />
        </div>
      </div>
    </div>
    <!-- Actual Content -->
    <div v-for="(block, i) in article.blocks" :key="`article-block${i + 1}`" class="article-space">
      <div class="article-block">
        <!-- Texte -->
        <TextBlock v-if="block.type === 'textblocks'" :textblock="$store.state.TaktNews.textblocks[block.id]"
          :has_permission_edit="false" :editing="false"
          :block_id="`text-block${block.id}`" :is_selected="current_block === `text-block${block.id}`" />
        <!-- Images, Videos, etc. -->
        <MediaBlock v-else :mediablock="$store.state.TaktNews.mediablocks[block.id]"
          :editing="false" :has_permission_edit="false"
          :block_id="`media-block${block.id}`" :is_selected="current_block === `media-block${block.id}`" />
      </div>
    </div>
  </div>
</template>

<script>
import TitleBlock from '@/components/Articles/TitleBlock.component.vue';
import TextBlock from '@/components/Articles/TextBlock.component.vue';
import MediaBlock from '@/components/Articles/MediaBlock.component.vue';
import Hashtag from '@/components/Articles/Hashtag.component.vue';
import { mapActions } from 'vuex';
import store from '@/store/index';

export default {
  components: {
    TitleBlock,
    TextBlock,
    MediaBlock,
    Hashtag,
  },
  props: [
    'job_id'
  ],
  beforeRouteEnter(to, from, next){
    console.log('test', to);
    store.dispatch('TaktNews/requestJob', {category_id: 0, article_id: to.params.job_id}).then(() => {
      next();
    });
  },
  beforeRouteUpdate(to, from, next){
    store.dispatch('TaktNews/requestJob', {category_id: 0, article_id: to.params.job_id}).then(() => {
      next();
    });
  },
  data: () => ({
    current_block: '',
    is_show_hashtag_error: false,
  }),
  computed: {

    article() {
      return this.$store.state.TaktNews.careers[this.job_id];
    },

    hashtags() {
      let arr = [];
      if(!this.article.hashtags) {
        return arr;
      }

      for(let i = 0; i < this.article.hashtags.length; i++) {
        arr.push(this.article.hashtags[i])
      }

      return arr;
    },

    authors() {
      let s = '<span>';
      if(this.article.authors.length >= 1) {
        s += 'Ansprechpartner: ';
        s += `<span class="author-name">${ this.article.authors[0].first_name } ${ this.article.authors[0].last_name }</span>`;
      }

      for(let i = 1; i < this.article.authors.length; i++) {
        s += `, <span class="author-name">${ this.article.authors[i].first_name } ${ this.article.authors[i].last_name }</span>`;
      }
      s += '</span>'
      return s;
    },

  },
  methods: {
    ...mapActions('TaktNews', [
      'requestJob',
    ]),
    getArticleDate(article) {
      if(article.published == 'public') {
        return this.formatDate(article.publish_date);
      }

      return this.date_today;
    },
    formatDate(date_string) {
      if(!date_string) {
        return this.date_today;
      }

      let date = date_string.substring(0, 10).replace(/[-]/g, '/');
      return date;
    },
  }
}
</script>
<style scoped>
.article-view-wrapper {
  padding: 0 10%;
}
.article-block {
  position: relative; /* for editBtn */
}
.article-line {
  border-style: solid;
  border-color: white;
  border-width: 0 0 1px 0;
}
.article-head-space {
  margin: 30px 0 20px 0;
}
.article-subheader {
  display: flex;
  flex-direction: row;
  /* margin-bottom: 24px; */
}
.article-hashtag-container {
  display: flex;
  grid-column-gap: calc(var(--grid-space) * 1px);;
  grid-row-gap: calc(var(--grid-space) * 1px);;
  justify-content: center;
  flex-wrap: wrap;
}
h2, .author-name {
  font-weight: 300;
  font-size: 12pt;
  font-style: italic;
  width: 50%;
}
h3 {
  font-weight: 300;
  font-size: 14pt;
  width: 50%;
}
.right {
  text-align: right;
}
.left {
  text-align: left;
}
.article-space {
  padding: 20px 0;
}
</style>